const tools = require('../../tools')
const { getGroup } = require('../read/get')
const { listOrdersForUser } = require('../read/internal')
const { createWarehouseSuborders } = require('./create-warehouse-suborders')
const { acceptOrders } = require('./accept-orders')

exports.advanceStatus = async function (
  state, {
    groupId,
    programId,
    dryRun = false,
    date = new Date().toJSON(),
    facilityOrdering,
    supplierId = null,
    api = null,
    noFunderSpecificLedger = false
  }
) {
  tools.validateParams('advanceStatus', arguments[1])
  // Using user status instead of group status so a orders:requester user never bumps
  // a `warehouse` status to `accepted` status
  const userStatus = tools.getUserStatus(state.user)
  const nextStatus = tools.getNextStatus(userStatus)

  const withSnapshots = true

  // TODO: If duplicate destinations ticket here:
  // https://github.com/fielded/van-orga/issues/2695
  const {orders, status: groupStatus} = groupId
    ? await getGroup(state, {groupId, withSnapshots})
    // always filter out accepted orders, they are not advanced through the UI
    : await listOrdersForUser(state, programId, state.user.location.id, {withSnapshots, withAccepted: false})

  if (groupId && userStatus !== groupStatus) {
    throw new Error(`user cannot advance group ${groupId},
      user status is ${userStatus} while group status is ${groupStatus}`)
  }

  const updatedSnapshots = tools.advanceStatusSnapshots({
    orders,
    currentStatus: userStatus
  })

  // Run the next-status work first and only persist the completed snapshots
  // after it succeeds. Persisting first stranded groups at the current status
  // with isComplete: true when acceptance failed (issue 25566).
  let result
  if (nextStatus === 'warehouse') {
    // createWarehouseSuborders persists the completed snapshots together with
    // the new warehouse suborders in one write, so the group can never be left
    // half-advanced.
    result = await createWarehouseSuborders(state, {groupId, dryRun, date, facilityOrdering, supplierId, api, completedSnapshots: updatedSnapshots})
  } else if (nextStatus === 'accepted') {
    result = await acceptOrders(state, {snapshots: updatedSnapshots, programId, date, dryRun, noFunderSpecificLedger, api})
    if (!dryRun) await state.dal.order.bulkDocs(state, updatedSnapshots)
  } else {
    result = {
      orders: tools.ordersFromSnapshotUpdates({
        updatedSnapshots, orders, status: userStatus, locationId: state.user.location.id
      })
    }
    if (!dryRun) await state.dal.order.bulkDocs(state, updatedSnapshots)
  }

  return result
}
